/**
 * Who may read the error feed.
 *
 * Firestore rules are the real gate (`allow read: if request.auth != null &&
 * isAdmin()`); this list only drives what the UI offers, so that a non-admin
 * who signs in gets told so instead of watching an empty page and guessing.
 */
export const ADMIN_EMAILS = ['org@someta.app', 'zach@someta.app'];

export function isAdminEmail(email: string | null | undefined): boolean {
  return !!email && ADMIN_EMAILS.includes(email);
}
